import { createSlice } from "@reduxjs/toolkit";
import { USER_ROLES } from "../../app.constants";
import type { RootState } from "../../app.store";
import type { IEmployee } from "../employee/employee.types";
import type { AuthInitialState, VerifyPayload } from "./auth.types";

const initialState: AuthInitialState = {
  theme: "light",
  role: USER_ROLES.USER,
  accessToken: undefined,
  refreshToken: undefined,
  employee: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    verifyUser: (state, { payload }: { payload: VerifyPayload }) => {
      state.accessToken = payload?.accessToken;
      state.refreshToken = payload?.refreshToken;

      // Persist to localStorage
      localStorage.setItem("accessToken", payload.accessToken);
      localStorage.setItem("refreshToken", payload.refreshToken);
    },
    userLoggedOut: (state) => {
      state.accessToken = undefined;
      state.refreshToken = undefined;
      state.employee = undefined;
      // Clear localStorage
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
    },
    setAuthInfo: (state, { payload }: { payload: VerifyPayload }) => {
      state.accessToken = payload?.accessToken;
      state.refreshToken = payload?.refreshToken;
    },
    setEmployee: (state, { payload }: { payload: IEmployee }) => {
      state.employee = payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
      if (typeof window !== "undefined") {
        localStorage.setItem("theme", action.payload); // persist in localStorage
      }
    },
    toggleTheme: (state) => {
      state.theme = state.theme === "light" ? "dark" : "light";
      // if (typeof window !== 'undefined') {
      //   localStorage.setItem('theme', state.theme);
      // }
    },
  },
});

export const {
  userLoggedOut,
  setAuthInfo,
  toggleTheme,
  verifyUser,
  setTheme,
  setEmployee,
} = authSlice.actions;
export const authReducer = authSlice.reducer;

/* ------ Selectors ------ */
export const selectAuth = (state: RootState) => state.auth;
